import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TenderService } from '../../../services/tender.service';
import { LoadingState } from '../../loading/loading.component';
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';

@Component({
  selector: 'app-add-partner-modal',
  templateUrl: './add-partner-modal.component.html',
  styleUrls: ['./add-partner-modal.component.scss']
})
export class AddPartnerModalComponent implements OnInit {
  loading: LoadingState = LoadingState.NotReady;
  form: FormGroup;
  tenderId: number;
  constructor(
    public dialogRef: MatDialogRef<AddPartnerModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private tenderService: TenderService,
    private formBuilder: FormBuilder,
  ) {
    console.log(data)
  }

  ngOnInit() {
    this.tenderId = this.data.tenderId
    this.loading = LoadingState.Ready;
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      contact: ['', Validators.required],
      address: ['', Validators.required],
      tender: [this.tenderId, Validators.required]
    });
    console.log(this.tenderId)
  }

  close() {
    this.dialogRef.close(true);
  }

  save() {
    if (this.form.valid) {
      this.loading = LoadingState.Processing;
      this.tenderService.addPartner(this.form.value).subscribe(
        res => {
          console.log(res)
          this.loading = LoadingState.Ready;
          this.dialogRef.close({ data: res });
        },
        error => {
          console.log(error)
          this.loading = LoadingState.Ready;
        }
      )

    }
    else {
      this.markFormGroupTouched(this.form)
    }

  }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        control.controls.forEach(c => this.markFormGroupTouched(c));
      }
    });
  }

  isFieldValid(form: FormGroup, field: string) {
    return !form.get(field).valid && (form.get(field).dirty || form.get(field).touched);
  }

  displayFieldCss(form: FormGroup, field: string) {
    return {
      'is-invalid': form.get(field).invalid && (form.get(field).dirty || form.get(field).touched),
      'is-valid': form.get(field).valid && (form.get(field).dirty || form.get(field).touched)
    };
  }

}
